export default {
  data: () => ({

    rawData:  [],
    
    header:   {},
    table:    {},
    columns:  [],
    keys:     {},
    filter:   {},
    axis:     null,
    
    canvasForms:  null,
  }),




  computed: {
    ready2draw() {
      return (
        this.DataItems.length > 0 &&
        Object.keys(this.Canvas).length > 0
      )
    },
  },
}